import { productsMapper } from './products-mapper';
import { toQueryString } from './to-querystring';

const CACHE = {};

/**
 * Clear the request cache (for testing).
 */
export function clearNewItemsCache() {
  Object.keys(CACHE).forEach((key) => delete CACHE[key]);
}

/**
 * Fetch products list.
 * @returns {Promise<Product[]>}
 */
export async function getNewItems(url, query, type) {
  const queryParams = toQueryString(query);
  const apiUrl = `${window.location.origin}${url}?${queryParams}`;
  const cacheKey = `${apiUrl}`;

  if (CACHE[cacheKey]) {
    return await CACHE[cacheKey];
  }

  const response = await fetch(apiUrl, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    cache: 'no-store'
  });

  const items = await response.json();
  let itemsData;
  if (type !== 'product') {
    itemsData = items.Data;
  } else {
    itemsData = productsMapper(items.Data);
  }

  CACHE[cacheKey] = { data: itemsData, queryString: items.Query };

  return { data: itemsData, queryString: items.Query };
}
